import { defa } from 'defa-object';
import Forecast from 'scripts/defa/weather/model-forecast';

/**
 * defa.models.Weather
 * The DEFA Weather model.
 * @version 1.3.0
 */
const apiHost = defa.vars.apiHost;

const api = {
	weather: apiHost + '/weather/location/', 
};

const Forecasts = Bb.Collection.extend({
	model : Forecast,	
	location: null,
	weatherUrl: '',

	url: function() {
		return api.weather + this.location.id;
	},
	
	// -----------------------------------------
	// event handlers
	// -----------------------------------------
	
	// -----------------------------------------
	// other functions
	// -----------------------------------------

	parse: function( response ) {
		this.weatherUrl = response.weatherUrl;
		for(let index in response.forecast) {
			let forecast = new Forecast();
			let element = response.forecast[index];
			forecast.set({from : new Date(element.from)});
			forecast.set({to : new Date(element.to)});
			forecast.set({symbol : element.symbol});
			forecast.set({windDirection : element.windDirection});
			forecast.set({windSpeed : element.windSpeed});
			forecast.set({temperature : element.temperature});

			forecast.setIconPath();
			forecast.setBackgroundPositionForWind();
			forecast.setDayName();

			let now = new Date();

			if(forecast.get('to').getTime() > now.getTime()) {
				this.add(forecast);
			}
		}
		this.trigger('parse:complete', this);
		return this.toJSON();
	},
	
});

export default Forecasts;